import type { ReactNode } from 'react';

export const symbol_ice_skating: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M110-80q-12.75 0-21.37-8.68Q80-97.35 80-110.18q0-12.82 8.63-21.32Q97.25-140 110-140h130v-110h-60q-24.75 0-42.37-17.63Q120-285.25 120-310v-470q0-24.75 17.63-42.38Q155.25-840 180-840h240q24.75 0 42.38 17.62Q480-804.75 480-780v120q0 30.42 13.5 55.21T536-572l115 29q48 12 78.5 52.05Q760-450.89 760-400v90q0 24.75-17.62 42.37Q724.75-250 700-250h-60v110h90q54.17 0 92.08-37.92Q860-215.83 860-270q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38 0 75-57.5 132.5T730-80H110Zm70-230h520v-90.47Q700-431 681.5-454t-47.08-31L519-515q-38-11-57.5-34.5T431-605h-95q-6 0-10.5-4.5T321-620q0-6 4.5-10.5T336-635h86q-2-13-2-24.5V-685h-84q-6 0-10.5-4.5T321-700q0-6 4.5-10.5T336-715h84v-65H180v470Zm120 170h280v-110H300v110ZM180-310Z"
		/>
	</svg>
);
